export interface PubSub {
  subscribe(type: string, subFn: (value: any) => void): void;
  unsubscribe(type: string, subFn: (value: any) => void): void;
  notify(type: string, data: any): void;
}

export interface Topic {
  name: string;
  callback: (value: any) => void;
}

export class PubSubImpl implements PubSub {
  private topics: Topic[] = [];

  subscribe(type: string, subFn: (value: any) => void): void {
    const topic: Topic = {
      name: type,
      callback: subFn,
    };

    if (this.topicExist(type, subFn)) {
      return;
    }

    this.topics.push(topic);
    window.addEventListener(type, subFn as EventListener, false);
  }

  unsubscribe(type: string, subFn: (value: any) => void): void {
    if (!this.topicExist(type, subFn)) {
      return;
    }

    this.topics = this.topics.filter(
      (topic) => !(topic.name === type && topic.callback === subFn)
    );

    window.removeEventListener(type, subFn as EventListener);
  }

  notify(type: string, data: any): void {
    const customEvent: CustomEvent = new CustomEvent(type, { detail: data });
    window.dispatchEvent(customEvent);
  }

  private topicExist(type: string, subFn: (value: any) => void): boolean {
    const result = this.topics.some((topic) => {
      return topic.name === type && topic.callback === subFn;
    });

    return result;
  }
}

export const pubsub = new PubSubImpl();
